import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import List from './components/List';
const CheckLeak = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Kiểm tra rò rỉ' }, { name: 'Dữ liệu kiểm tra' }]}
        />
      </div>
      <List />
    </ContainerBody>
  );
};
export default compose(withPaginate)(CheckLeak);
